export default __webpack_public_path__ + "static/media/banner-smile.87af4bf9.jpg";